export const STRICTLY_NECESSARY = ["Iterable", "Google Tag Manager"];
